import * as THREE from '../chapter3/three';
import {TweenMax} from 'gsap';
const shaders = {

    basic:        require('../../shaders/basic.glsl'),
    finalQuad:    require('../../shaders/finalquad.frag'),
    kernel :      require('raw!../../shaders/kernel.vertex'),
    advect :      require('../../shaders/advect.frag'),
    boundy :      require('raw!../../shaders/boundy.vertex'),
    cursor :      require('raw!../../shaders/cursor.vertex'),
    addstrength : require('../../shaders/addstrength.frag'),
    divergence :  require('../../shaders/divergence.frag'),
    compute :     require('../../shaders/compute.frag'),
    subtractpressyGradient : require('../../shaders/subtractpressygradient.frag'),
    colorKernel : require('../../shaders/color.vert'),
    colorKernelFrag : require('../../shaders/color.frag')
}

import background_image_01 from '../../images/generator/generator_1.jpg';
import background_image_02 from '../../images/generator/generator_2.jpg';
import background_image_03 from '../../images/generator/generator_3.jpg';
import background_image_04 from '../../images/generator/generator_4.jpg';
import background_image_05 from '../../images/generator/generator_5.jpg';
import background_image_06 from '../../images/generator/generator_6.jpg';

const bg_images = [
  background_image_01,
  background_image_02,
  background_image_03,
  background_image_04,
  background_image_05,
  background_image_06,
]

class PostProcessing {

    constructor(scene,camera, renderer,config,cb) {
        this.config = config;

       
        this.raycaster = new THREE.Raycaster();
        this.scene = scene;
        this.originalcamera = camera;
        this.camera = camera;
        //this.camera = new THREE.OrthographicCamera(1, 1, 1, 1, -10000, 10000);
        this.renderer = renderer;
        this.hasMove = false;
        this.mouse = new THREE.Vector2();
        this.originalmouse = new THREE.Vector2();
        this.bg_images = [];
        this.x0 = 0;
        this.y0 = 0;
        
        this.options = {
          iterations: 40,
          mouse_strength: 0.033,
          cSize: 70 ,
          step: 0.033,
          colorBrushSize: 0.0
        };

        //Sizes
          this.px_x = 1.0/this.renderer.domElement.width;
          this.px_y = 1.0/this.renderer.domElement.height;
          this.px = new THREE.Vector2(this.px_x, this.px_y);
          this.px1 = new THREE.Vector2(1, this.renderer.domElement.width / this.renderer.domElement.height);
        

        var max = 3;
        var lineGeometry = new THREE.BufferGeometry();
            lineGeometry.addAttribute( 'position', new THREE.Float32Attribute( [
                          // bottom
                          -max, -max, 0,
                           max, -max, 0,
                           max,  max, 0,
                           -max, max, 0                          
                      ], 3 ) );

        this.geom = {
            all    : new THREE.PlaneBufferGeometry(2, 2),
            inside :  new THREE.PlaneBufferGeometry(1.99, 1.99),
            boundy : lineGeometry,
            cursor: new THREE.PlaneBufferGeometry(this.px_x * this.options.cSize*2, this.px_y * this.options.cSize * 2)
        }

         //load resources
        this.manager = new THREE.LoadingManager();
        this.manager.onProgress = ( item, loaded, total )=>{
        
          if(loaded == total){
            this.initFBOS();

            this.setIterations(40);

            cb();
          }
        };
        this.loader = new THREE.TextureLoader(this.manager);

        this.normaltex =   this.loader.load(this.config.normaltex_url);

        bg_images.forEach((img,index)=>{
          this.bg_images.push( {id:index, img: this.loader.load(img)} );
        });

        this.diffuse =  this.loader.load(this.config.backgroundtex_url);


    }//eof constructor

   

    initFBOS() { 

      this.diffuse.wrapS = this.diffuse.wrapT = THREE.RepeatWrapping;

      this.diffuse.minFilter = THREE.LinearFilter;
      this.diffuse.magFilter = THREE.LinearFilter;
        
      this.normaltex.minFilter = THREE.LinearFilter;
      this.normaltex.magFilter = THREE.LinearFilter;


        this.velocityFBO0 =  this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.velocityFBO1 =  this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.divergenceFBO = this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.pressyFBO0 =  this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.pressyFBO1 =  this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.drawFBO =  this.fbos(this.config.size, this.config.size, THREE.RGBFormat, THREE.HalfFloatType);
        this.colormapFBO =  this.fbos(this.config.size, this.config.size, THREE.RGBAFormat, THREE.HalfFloatType);
        this.colormapFB1 =  this.fbos(this.config.size, this.config.size, THREE.RGBAFormat, THREE.HalfFloatType);


        this.advectVelocityKernel = {

            geom: this.geom.inside,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                    px: {type: "v2", value: this.px},
                    px1: {type: "v2", value: this.px1},
                    scale: {type: "float", value: 1.0},
                    velocity: {type: "t", value: this.velocityFBO0},
                    source: {type: "t", value: this.velocityFBO0},
                    dt: {type: "f", value: this.options.step}
                },
                vertexShader: shaders.kernel,
                fragmentShader: shaders.advect,
                            

            }),

            output: this.velocityFBO1
        }

        this.advectVelocityKernel.mesh = new THREE.Mesh(this.advectVelocityKernel.geom, this.advectVelocityKernel.mat)


        this.velocityboundyKernel = {

            geom : this.geom.boundy,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   px: {type: "v2", value: this.px},
                   scale: {type: "float", value: -1.0},
                   velocity: {type: "t", value: this.velocityFBO0},
                   source: {type: "t", value: this.velocityFBO0},
                   dt: {type: "f", value: 1/60}
               },
               vertexShader: shaders.boundy,
               fragmentShader: shaders.advect

            }),

            output: this.velocityFBO1
        }

        this.velocityboundyKernel.mesh = new THREE.Line(this.velocityboundyKernel.geom, this.velocityboundyKernel.mat)


        this.addstrengthKernel = {

            geom: this.geom.cursor,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   px: {type: "v2", value: this.px},
                   strength: {type: "v2", value: new THREE.Vector2(0.5, 0.2)},
                   center: {type: "v2", value: new THREE.Vector2(0.1, 0.4)},
                   scale: {type: "v2", value: new THREE.Vector2(this.options.cSize * this.px_x, this.options.cSize*this.px_y)}
               },

               vertexShader: shaders.cursor,
               fragmentShader: shaders.addstrength,
               transparent: true,
               blending: THREE.AdditiveBlending
              
            }),

            output: this.velocityFBO1
        }

        this.addstrengthKernel.mesh = new THREE.Mesh(this.addstrengthKernel.geom, this.addstrengthKernel.mat)



        this.divergenceKernel = {

            geom: this.geom.all,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   px: {type: "v2", value: this.px},
                   velocity: {type: "t", value: this.velocityFBO1}
               },

               vertexShader: shaders.kernel,
               fragmentShader: shaders.divergence


            }),
            output: this.divergenceFBO
        }

        this.divergenceKernel.mesh = new THREE.Mesh(this.divergenceKernel.geom, this.divergenceKernel.mat)


        this.computeKernel = {

            geom: this.geom.all,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   px: {type: "v2", value: this.px},

                   alpha: {type: "f", value: -1.0},
                   beta: {type: "f", value: 0.25},
                   pressy: {type: "t", value: this.pressyFBO0},
                   divergence: {type: "t", value: this.divergenceFBO}
               },
               vertexShader: shaders.kernel,
               fragmentShader: shaders.compute

            }),

            output: this.pressyFBO1
        }

        this.computeKernel.mesh = new THREE.Mesh(this.computeKernel.geom, this.computeKernel.mat)




        this.pressyboundyKernel = {

            geom: this.geom.boundy,

            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   px: {type: "v2", value: this.px},

                   alpha: {type: "f", value: -1.0},
                   beta: {type: "f", value: 0.25},
                   pressy: {type: "t", value: this.pressyFBO0},
                   divergence: {type: "t", value: this.divergenceFBO}
               },
               vertexShader: shaders.boundy,
               fragmentShader: shaders.compute

            }),

            output: this.pressyFBO1
        }

        this.pressyboundyKernel.mesh = new THREE.Line(this.pressyboundyKernel.geom, this.pressyboundyKernel.mat)
        this.subtractpressyGradientKernel = {

            geom: this.geom.all,
            clear: false,
            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   scale: {type: "f", value: 1.0},
                   px: {type: "v2", value: this.px},
                   pressy: {type: "t", value: this.pressyFBO0},
                   velocity: {type: "t", value: this.velocityFBO1}
               },
               vertexShader: shaders.kernel,
               fragmentShader: shaders.subtractpressyGradient

            }),
            output: this.velocityFBO0
        }

        this.subtractpressyGradientKernel.mesh = new THREE.Mesh(this.subtractpressyGradientKernel.geom, this.subtractpressyGradientKernel.mat)



        this.subtractpressyGradientboundyKernel = {
            geom: this.geom.boundy,
            mat: new THREE.RawShaderMaterial({

                uniforms: {
                   scale: {type: "f", value:  -1.0},
                   px: {type: "v2", value: this.px},
                   pressy: {type: "t", value: this.pressyFBO0},
                   velocity: {type: "t", value: this.velocityFBO1}
               },
               vertexShader: shaders.boundy,
               fragmentShader: shaders.subtractpressyGradient
            }),

            output: this.velocityFBO0
        }

        this.subtractpressyGradientboundyKernel.mesh = new THREE.Mesh(this.subtractpressyGradientboundyKernel.geom, this.subtractpressyGradientboundyKernel.mat)


         this.colorKernel = {

            geom: this.geom.all,
            mat: new THREE.RawShaderMaterial({

                uniforms: {

                   source: {type:"f", value: this.colormapFBO},
                   center: {type: "v2", value: new THREE.Vector2(0.5, 0.5)},
                   scale: {type: "v2", value: new THREE.Vector2(this.options.cSize * this.px_x * this.options.colorBrushSize, this.options.cSize * this.px_y * this.options.colorBrushSize)},
                   colorpen: {type: "c", value: new THREE.Color(0, 82 / 255, 1)}
               
               },

               vertexShader: shaders.colorKernel,
               fragmentShader: shaders.colorKernelFrag,

               transparent : true

            }),

            output: this.colormapFB1
        }

        this.colorKernel.mesh = new THREE.Mesh(this.colorKernel.geom, this.colorKernel.mat)


        

        this.finalQuadKernel = {

            geom:  new THREE.RingBufferGeometry( 0.0001, 2.6, 120, 120 ),
            mat: new THREE.RawShaderMaterial({

                uniforms: {
                   
                   pressy: {type: 't', value: this.pressyFBO0},
                   velocity: {type: 't', value: this.velocityFBO0},
                   colormap: {type: 't', value: this.colormapFB1},

                   diffuse: {type: "t", value: this.diffuse},
                   tnormal: {type: "t", value: this.normaltex}

               },
               side: 2,
               transparent : true,
               vertexShader: shaders.basic,
               fragmentShader: shaders.finalQuad

            }),

            output: this.drawFBO
        }

        this.finalQuadKernelMesh = new THREE.Mesh( this.finalQuadKernel.geom,  this.finalQuadKernel.mat)

        this.scene.add(this.finalQuadKernelMesh)

    }

    render(scene, camera) {

        if(this.hasMove) {


          this.raycaster.setFromCamera( this.originalmouse, this.originalcamera ); 

          var intersects = this.raycaster.intersectObjects( [this.finalQuadKernelMesh] );

         
          if(intersects.length > 0) {
         
            TweenMax.set(this.mouse, {
              x: intersects[0].uv.x * this.w,
              y: this.h - intersects[0].uv.y * this.h
            })

            this.colorKernel.mesh.material.uniforms.center.value.x = this.mouse.x / this.w;
            this.colorKernel.mesh.material.uniforms.center.value.y = 1.0 - this.mouse.y/ this.h;
            this.compute(this.colorKernel, false);

          }

          this.hasMove = false;

        }
    
        var x1 = this.mouse.x ,
            y1 = this.mouse.y ,
            xd = x1-this.x0,
            yd = y1-this.y0;

        this.x0 = x1,
        this.y0 = y1;
        if(this.x0 === 0 && this.y0 === 0){
          xd = yd = 0;
        }

       
        this.advectVelocityKernel.mat.uniforms.dt.value = this.options.step;

        this.compute(this.advectVelocityKernel, false)

        this.addstrengthKernel.mesh.material.uniforms.strength.value.x = xd * this.px_x * this.options.cSize * this.options.mouse_strength;
        this.addstrengthKernel.mesh.material.uniforms.strength.value.y = -yd * this.px_y * this.options.cSize * this.options.mouse_strength;
        this.addstrengthKernel.mesh.material.uniforms.center.value.x = this.x0 * this.px_x * 2 -1.0;
        this.addstrengthKernel.mesh.material.uniforms.center.value.y = (this.y0 * this.px_y * 2 -1.0) * -1;

        this.compute(this.addstrengthKernel, false)

        this.compute(this.velocityboundyKernel, false)
        
        this.compute(this.divergenceKernel, false)

        var p0 = this.pressyFBO0,
            p1 = this.pressyFBO1,
            p_ = p0;
        for(var i = 0; i < this.options.iterations; i++) {
            this.computeKernel.mat.uniforms.pressy.value = this.pressyboundyKernel.mat.uniforms.pressy.value = p0;
            this.computeKernel.output = this.pressyboundyKernel.output = p1;
            this.compute(this.computeKernel, false);
            this.compute(this.pressyboundyKernel, false);
            
            p_ = p0;
            p0 = p1;
            p1 = p_;
        }

        this.compute(this.subtractpressyGradientKernel, false);
                

        this.renderer.render(this.scene, this.camera);

        

    }

   
    compute(prop, toScreen) {

        this.scene.add(prop.mesh)

        if(toScreen == true) {

            this.renderer.render(this.scene, this.camera);
            
        }

        else {


            this.renderer.setRenderTarget( prop.output );
            
            this.renderer.objects.update(prop.mesh);

            this.renderer.renderBufferDirect( this.camera, null, prop.mesh.geometry, prop.mesh.material, prop.mesh, null );

           
        }

        this.scene.remove(prop.mesh)

    }

    resize(w, h) {


        this.w = this.renderer.domElement.width;
        this.h = this.renderer.domElement.height;

        this.px_x = 1.0/this.w;
        this.px_y = 1.0/this.h;
        this.px = new THREE.Vector2(this.px_x, this.px_y);
        this.px1 = new THREE.Vector2(1, this.w  / this.h);

        this.advectVelocityKernel.mat.uniforms.px.value = this.px;
        this.advectVelocityKernel.mat.uniforms.px1.value = this.px1;
        this.addstrengthKernel.mat.uniforms.px.value = this.px;

        this.velocityboundyKernel.mat.uniforms.px.value = this.px;

        this.advectVelocityKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.velocityboundyKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.addstrengthKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.divergenceKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.computeKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.pressyboundyKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.subtractpressyGradientKernel.mesh.scale.set(this.config.size,this.config.size,1);
        this.subtractpressyGradientboundyKernel.mesh.scale.set(this.config.size,this.config.size,1);
        // this.drawKernel.mesh.scale.set(size,size,1)
        this.colorKernel.mesh.scale.set(this.config.size,this.config.size,1);

        this.subtractpressyGradientboundyKernel.mat.uniforms.px.value = this.px;
    }


    reset() {
      
     this.renderer.clearTarget( this.velocityFBO0, true, true, true);
     this.renderer.clearTarget( this.velocityFBO1, true, true, true);
     this.renderer.clearTarget( this.divergenceFBO, true, true, true);
     this.renderer.clearTarget( this.pressyFBO0, true, true, true);
     this.renderer.clearTarget( this.pressyFBO1, true, true, true);
     this.renderer.clearTarget( this.drawFBO, true, true, true);
     this.renderer.clearTarget( this.colormapFBO, true, true, true);
     this.renderer.clearTarget( this.colormapFB1, true, true, true);

    }

    setIterations(value) {
      this.options.iterations = value
    }

    faketouch() {
      this.hasMove = true;
        
      this.originalmouse.x =  (Math.random() -  Math.random()) / 50.0
      this.originalmouse.y =  (Math.random() -  Math.random()) / 50.0

    }

    setBackgroundTexture(t){
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      t.minFilter = THREE.LinearFilter;
      t.magFilter = THREE.LinearFilter;

      this.finalQuadKernelMesh.material.uniforms.diffuse.value = t;
    }
    

    changeBG( num ){

      this.bg_images.forEach((data,index)=>{
        if(data.id == num ){
          this.setBackgroundTexture(data.img);
        }
      });
      
    }

    setCSize(val) {
      
      this.options.cSize = val;

     // console.log('val', val)
    }


    setStep(val) {

      this.options.step = val;
    }

    setBrushSize(size) {

      this.options.colorBrushSize = size;

      this.colorKernel.mesh.material.uniforms.scale.value.x = this.options.cSize * this.px_x * this.options.colorBrushSize;
      this.colorKernel.mesh.material.uniforms.scale.value.y = this.options.cSize * this.px_y * this.options.colorBrushSize;

    }

    setColor(color) {

      this.colorKernel.mesh.material.uniforms.colorpen.value.x = color.r / 255;
      this.colorKernel.mesh.material.uniforms.colorpen.value.y = color.g / 255;
      this.colorKernel.mesh.material.uniforms.colorpen.value.z = color.b / 255;

    }

    toType(obj) {

        return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()

    }
    

    fbos(w, h, format, type) {


      return new THREE.WebGLRenderTarget(w, h, {

          minFilter: THREE.LinearFilter,
          magFilter: THREE.LinearFilter,
          format: format,
          type: type,
          wrapS:  THREE.RepeatWrapping,
          wrapT:  THREE.RepeatWrapping
          

        });

    }

}

export default PostProcessing;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/postprocessing.js